var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoinWaitlistPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1146,
    height: 561,
    viewBox: "0 0 1146 561",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M853.921 -173.36C795.262 -263.324 631.067 -260.911 529.823 -211.938C413.155 -155.491 408.279 -50.8372 307.016 -34.4918C214.621 -19.5476 171.453 -99.1199 105.5 -83.9253C44.889 -69.9584 -19.0339 20.3604 -47.7855 332.551",
    stroke: "url(#paint0_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-35.8529 340.193C-7.18611 32.3598 55.8906 -59.8933 116.254 -76.4198C161.019 -88.612 195.597 -56.3582 242.539 -40.4825C266.196 -32.0729 291.569 -29.6705 316.382 -33.491C397.682 -45.9491 418.429 -112.476 485.4 -168.243C502.443 -182.517 521.104 -194.737 541.001 -204.652C641.936 -255.365 800.801 -265.212 859.91 -179.735",
    stroke: "url(#paint1_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.9189 347.794C4.67098 44.3342 66.8594 -49.8134 126.867 -68.8283C170.978 -82.8022 205.615 -52.8868 251.883 -38.6209C275.658 -30.9678 300.864 -28.8445 325.582 -32.4129C406.015 -44.0392 428.912 -105.938 496.585 -160.9C513.764 -174.909 532.347 -187.1 552.037 -197.28C652.828 -249.425 806.191 -267.03 865.749 -186.041",
    stroke: "url(#paint2_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-12.0179 355.369C16.4852 56.3487 77.843 -39.7 137.537 -61.2844C181.044 -77.0223 215.658 -49.4473 261.31 -36.798C285.162 -29.8938 310.19 -28.0358 334.797 -31.3425C414.431 -42.168 439.32 -99.3863 507.786 -153.564C525.089 -167.356 543.609 -179.547 563.116 -189.988C663.66 -243.74 811.607 -268.921 871.614 -192.42",
    stroke: "url(#paint3_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0781337 363.028C28.3246 68.3316 88.801 -29.5538 148.232 -53.731C191.093 -71.193 225.766 -45.9974 270.762 -35.0067C294.707 -28.8495 319.598 -27.2615 344.129 -30.326C422.963 -40.3507 449.902 -92.8949 519.187 -146.322C536.596 -159.831 555.019 -171.98 574.293 -182.661C674.606 -238.028 817.144 -270.767 877.617 -198.762",
    stroke: "url(#paint4_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.78 370.684C40.1478 80.3225 99.0533 -21.0427 158.919 -46.1942C201.63 -64.1936 235.82 -42.6637 280.189 -33.1831C304.207 -27.7942 328.959 -26.4769 353.412 -29.286C431.446 -38.5099 460.401 -86.3644 530.396 -138.969C547.905 -152.247 566.251 -164.384 585.321 -175.304C685.373 -232.353 822.526 -272.601 883.455 -205.066",
    stroke: "url(#paint5_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7884 378.27C51.9963 92.321 110.773 -9.14599 169.552 -38.7338C211.164 -59.4211 245.955 -39.247 289.641 -31.3519C313.71 -26.727 338.329 -25.6752 362.703 -28.2305C439.937 -36.6537 470.951 -79.8585 541.672 -131.648C559.292 -144.676 577.57 -156.792 596.432 -167.946C696.254 -226.61 827.967 -274.483 889.369 -211.387",
    stroke: "url(#paint6_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7129 385.895C63.7862 104.327 121.699 0.974286 180.285 -31.0978C221.187 -53.56 256.052 -35.9949 299.077 -29.5532C323.176 -25.6979 347.667 -24.9209 371.962 -27.241C448.387 -34.839 481.475 -73.3608 552.916 -124.393C569.549 -136.246 587.474 -148.543 607.504 -160.671C707.088 -221.008 833.43 -276.316 895.266 -217.74",
    stroke: "url(#paint7_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6376 393.52C75.6671 116.31 132.711 11.2775 190.941 -23.5868C231.218 -47.6822 266.174 -32.7339 308.538 -27.7867C332.666 -24.708 357.051 -24.1901 381.286 -26.2414C456.912 -33.0387 492.017 -66.9118 564.234 -117.112C581.043 -128.804 598.934 -141.044 618.665 -153.377C717.871 -215.3 838.886 -278.164 901.163 -224.093",
    stroke: "url(#paint8_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5718 401.121C87.5078 128.293 143.708 21.5471 201.652 -16.001C241.297 -41.7051 276.395 -29.4789 317.94 -25.9318C342.068 -23.6251 366.347 -23.3596 390.519 -25.1379C465.361 -31.1422 502.516 -60.3411 575.437 -109.817C592.34 -121.31 610.247 -133.558 629.688 -146.079C728.725 -209.787 844.296 -280.113 907.03 -230.513",
    stroke: "url(#paint9_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4958 408.746C99.3305 140.283 154.719 31.8503 212.289 -8.44111C251.309 -35.7374 286.467 -26.2354 327.358 -24.0841C351.471 -22.5723 375.655 -22.5718 399.768 -24.0827C473.793 -29.2784 512.99 -53.8199 586.71 -102.414C603.805 -113.713 621.654 -125.954 640.795 -138.639C739.548 -204.078 849.74 -281.855 912.957 -236.759",
    stroke: "url(#paint10_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4202 416.372C111.178 152.283 165.764 42.1389 223.009 -0.919344C261.429 -29.799 296.648 -23.0622 336.818 -22.2756C359.906 -21.8309 383.482 -21.5135 409.083 -23.0578C482.301 -27.4693 523.556 -47.32 598.01 -95.1234C615.257 -106.23 633.065 -118.472 651.956 -131.344C750.424 -198.515 855.254 -283.751 918.911 -243.118",
    stroke: "url(#paint11_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3456 423.997C123.05 164.332 176.709 52.5139 233.689 6.6411C271.5 -23.8385 306.814 -19.9236 346.262 -20.4606C369.542 -20.7747 393.043 -20.7465 418.366 -22.0187C490.808 -25.5796 534.064 -40.8149 609.279 -87.819C626.684 -98.7167 644.468 -110.968 663.019 -124.004C761.169 -192.931 860.67 -285.601 924.784 -249.439",
    stroke: "url(#paint12_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.237 431.637C134.85 176.272 187.844 62.8202 244.367 14.2019C281.593 -17.8278 316.972 -16.8012 355.714 -18.6287C379.186 -19.7425 402.603 -19.9791 427.59 -20.9314C499.225 -23.7492 544.522 -34.2449 620.562 -80.481C638.128 -91.2104 655.854 -103.455 674.129 -116.646C771.963 -187.371 866.118 -287.466 930.689 -255.775",
    stroke: "url(#paint13_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.204 439.221C146.69 188.254 198.879 73.213 255.055 21.7371C291.705 -11.8671 327.124 -13.7376 365.134 -16.8234C388.791 -18.7535 412.173 -19.2373 436.932 -19.9409C507.734 -21.9423 555.106 -27.7961 631.823 -73.194C650.225 -84.3422 668.044 -96.4253 685.21 -109.396C782.734 -181.82 871.633 -289.323 936.587 -262.13",
    stroke: "url(#paint14_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M131.129 446.847C158.538 200.254 210.023 83.4955 265.676 29.3052C301.757 -5.85682 337.217 -10.6655 374.594 -15.0152C398.428 -17.7783 421.742 -18.4937 446.214 -18.9007C516.233 -20.1092 565.638 -21.281 643.057 -65.8731C661.56 -76.7617 679.343 -88.8306 696.295 -102.005C793.457 -176.368 877.03 -291.165 942.477 -268.54",
    stroke: "url(#paint15_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M143.054 454.472C170.362 212.244 221.222 93.8934 276.414 36.8179C311.909 0.146803 347.395 -7.67435 384.014 -13.2091C408.017 -16.8217 431.286 -17.7189 455.481 -17.8538C524.683 -18.2537 576.146 -14.7758 654.359 -58.5842C672.952 -69.2347 690.693 -81.3079 707.424 -94.6958C804.219 -170.792 882.487 -293.014 948.414 -274.81",
    stroke: "url(#paint16_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M154.996 462.089C182.241 224.309 232.264 104.304 287.093 44.3782C322.07 6.12588 357.508 -4.69316 393.441 -11.3864C417.664 -15.913 440.839 -16.9686 464.764 -16.8147C533.15 -16.4471 586.663 -8.25406 665.635 -51.2633C684.311 -61.6849 702.013 -73.7639 718.527 -87.3546C814.949 -165.283 887.935 -294.879 954.32 -281.147",
    stroke: "url(#paint17_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M166.919 469.715C193.965 236.265 243.421 114.702 297.81 51.982C332.251 12.1972 367.626 -1.65294 402.931 -9.47045C427.28 -14.8066 450.478 -16.1161 474.092 -15.6746C541.694 -14.473 597.241 -1.63902 676.933 -43.8912C695.691 -54.0832 713.356 -66.1699 729.652 -79.9622C825.694 -159.739 893.52 -296.666 960.255 -287.416",
    stroke: "url(#paint18_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M178.844 477.34C205.88 248.233 254.595 125.091 308.458 59.4763C342.388 18.1269 377.667 1.22019 412.328 -7.75482C436.784 -14.0735 459.976 -15.4406 483.344 -14.7015C550.129 -12.6914 607.718 4.80011 688.185 -36.6196C707.03 -46.5736 724.662 -58.6706 740.732 -72.6704C836.353 -154.338 898.839 -298.593 966.129 -293.819",
    stroke: "url(#paint19_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M190.778 484.941C217.72 260.215 265.808 135.564 319.079 67.0439C352.498 24.1709 387.649 4.18217 421.689 -5.90049C446.26 -13.185 469.462 -14.6587 492.52 -13.6729C558.53 -10.8532 618.169 11.3125 699.372 -29.3169C718.297 -39.0513 735.903 -51.1619 751.762 -65.3552C846.817 -149.008 904.229 -300.41 971.994 -300.157",
    stroke: "url(#paint20_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M202.686 492.573C246.245 134.945 344.013 25.0067 431.199 -4.11678C526.373 -35.9116 600.089 31.7082 710.713 -22.0271C840.476 -85.0809 898.183 -301.59 977.932 -306.509",
    stroke: "url(#paint21_linear_1400_3776)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1400_3776",
    x1: 285.826,
    y1: -170.445,
    x2: 419.041,
    y2: 113.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1400_3776",
    x1: 297.997,
    y1: -162.965,
    x2: 431.231,
    y2: 121.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1400_3776",
    x1: 310.063,
    y1: -155.537,
    x2: 443.339,
    y2: 128.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1400_3776",
    x1: 322.093,
    y1: -148.227,
    x2: 455.448,
    y2: 136.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1400_3776",
    x1: 334.129,
    y1: -141.034,
    x2: 467.645,
    y2: 143.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1400_3776",
    x1: 345.967,
    y1: -133.981,
    x2: 479.719,
    y2: 151.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1400_3776",
    x1: 357.875,
    y1: -127.064,
    x2: 491.902,
    y2: 158.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1400_3776",
    x1: 369.73,
    y1: -120.148,
    x2: 504.043,
    y2: 166.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1400_3776",
    x1: 381.463,
    y1: -113.494,
    x2: 516.183,
    y2: 173.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1400_3776",
    x1: 393.174,
    y1: -106.909,
    x2: 528.325,
    y2: 181.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1400_3776",
    x1: 404.77,
    y1: -100.525,
    x2: 540.457,
    y2: 188.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1400_3776",
    x1: 416.316,
    y1: -94.3313,
    x2: 552.622,
    y2: 196.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1400_3776",
    x1: 427.73,
    y1: -88.3154,
    x2: 564.747,
    y2: 203.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1400_3776",
    x1: 439.045,
    y1: -82.5094,
    x2: 576.871,
    y2: 211.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1400_3776",
    x1: 450.267,
    y1: -77.0121,
    x2: 589.029,
    y2: 218.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1400_3776",
    x1: 461.335,
    y1: -71.796,
    x2: 601.178,
    y2: 226.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1400_3776",
    x1: 472.241,
    y1: -66.908,
    x2: 613.319,
    y2: 233.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1400_3776",
    x1: 479.318,
    y1: -70.2065,
    x2: 625.468,
    y2: 241.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1400_3776",
    x1: 486.045,
    y1: -74.2238,
    x2: 637.608,
    y2: 249.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1400_3776",
    x1: 492.532,
    y1: -78.7596,
    x2: 649.749,
    y2: 256.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1400_3776",
    x1: 498.895,
    y1: -83.5367,
    x2: 661.874,
    y2: 264.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1400_3776",
    x1: 505.156,
    y1: -88.5725,
    x2: 674.023,
    y2: 271.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinWaitlistPattern);
export default __webpack_public_path__ + "static/media/joinWaitlistPattern.5ef03316d564bc126e6b0734a7b297fd.svg";
export { ForwardRef as ReactComponent };